import {
  uploadPolicies,
  listUploadedPolicies,
  getFilteredPolicies,
  verifyPolicy as policyVerification,
  getPendingQuotes,
  getQuoteGoods,
  getQuotes,
  getPoliciesExcel
} from '../utils/apiService';

export const UPLOAD_POLICIES = 'policies/UPLOAD_POLICIES';
export const UPLOAD_POLICIES_PENDING = 'policies/UPLOAD_POLICIES_PENDING';
export const UPLOAD_POLICIES_REJECTED = 'policies/UPLOAD_POLICIES_REJECTED';
export const UPLOAD_POLICIES_FULFILLED = 'policies/UPLOAD_POLICIES_FULFILLED';

export const LIST_UPLOADED_POLICIES = 'policies/LIST_UPLOADED_POLICIES';
export const LIST_UPLOADED_POLICIES_PENDING =
  'policies/LIST_UPLOADED_POLICIES_PENDING';
export const LIST_UPLOADED_POLICIES_REJECTED =
  'policies/LIST_UPLOADED_POLICIES_REJECTED';
export const LIST_UPLOADED_POLICIES_FULFILLED =
  'policies/LIST_UPLOADED_POLICIES_FULFILLED';

export const FETCH_POLICIES = 'dashboard/FETCH_POLICIES';
export const FETCH_POLICIES_PENDING = 'dashboard/FETCH_POLICIES_PENDING';
export const FETCH_POLICIES_REJECTED = 'dashboard/FETCH_POLICIES_REJECTED';
export const FETCH_POLICIES_FULFILLED = 'dashboard/FETCH_POLICIES_FULFILLED';

export const VERIFY_POLICY = 'policies/VERIFY_POLICY';
export const VERIFY_POLICY_PENDING = 'policies/VERIFY_POLICY_PENDING';
export const VERIFY_POLICY_REJECTED = 'policies/VERIFY_POLICY_REJECTED';
export const VERIFY_POLICY_FUlFILLED = 'policies/VERIFY_POLICY_FULFILLED';

export const LIST_QUOTE_GOODS = 'policies/LIST_QUOTE_GOODS';
export const LIST_QUOTE_GOODS_PENDING = 'policies/LIST_QUOTE_GOODS_PENDING';
export const LIST_QUOTE_GOODS_REJECTED = 'policies/LIST_QUOTE_GOODS_REJECTED';
export const LIST_QUOTE_GOODS_FULFILLED = 'policies/LIST_QUOTE_GOODS_FULFILLED';

export const FETCH_PENDING_POLICIES = 'dashboard/FETCH_PENDING_POLICIES';
export const FETCH_PENDING_POLICIES_PENDING =
  'dashboard/FETCH_PENDING_POLICIES_PENDING';
export const FETCH_PENDING_POLICIES_REJECTED =
  'dashboard/FETCH_PENDING_POLICIES_REJECTED';
export const FETCH_PENDING_POLICIES_FULFILLED =
  'dashboard/FETCH_PENDING_POLICIES_FULFILLED';

export const FETCH_QUOTES = 'dashboard/FETCH_QUOTES';
export const FETCH_QUOTES_PENDING = 'dashboard/FETCH_QUOTES_PENDING';
export const FETCH_QUOTES_REJECTED = 'dashboard/FETCH_QUOTES_REJECTED';
export const FETCH_QUOTES_FULFILLED = 'dashboard/FETCH_QUOTES_FULFILLED';

export const GET_POLICIES_EXCEL = 'policies/GET_POLICIES_EXCEL';
export const GET_POLICIES_EXCEL_PENDING = 'policies/GET_POLICIES_EXCEL_PENDING';
export const GET_POLICIES_EXCEL_REJECTED =
  'policies/GET_POLICIES_EXCEL_REJECTED';
export const GET_POLICIES_EXCEL_FULFILLED =
  'policies/GET_POLICIES_EXCEL_FULFILLED';

export const uploadPolicyFile = policies => {
  console.log(policies);
  const payload = uploadPolicies(policies);
  return {
    type: UPLOAD_POLICIES,
    payload
  };
};

export const listPoliciesUploaded = () => {
  const payload = listUploadedPolicies();
  return {
    type: LIST_UPLOADED_POLICIES,
    payload
  };
};

export const fetchFilteredPolicies = filter => {
  const payload = getFilteredPolicies(filter);
  return {
    type: FETCH_POLICIES,
    payload
  };
};

export const verifyPolicy = policy => {
  const payload = policyVerification(policy);
  return {
    type: VERIFY_POLICY,
    payload
  };
};

export const fetchPendingPolicies = () => {
  const payload = getPendingQuotes();
  return {
    type: FETCH_PENDING_POLICIES,
    payload
  };
};

export const listQuoteGoods = quote_id => {
  return {
    type: LIST_QUOTE_GOODS,
    payload: getQuoteGoods(quote_id)
  };
};

export const fetchQuotes = filter => {
  return {
    type: FETCH_QUOTES,
    payload: getQuotes(filter)
  };
};

export const getExcel = date_range => {
  return {
    type: GET_POLICIES_EXCEL,
    payload: getPoliciesExcel(date_range)
  };
};



// WEBPACK FOOTER //
// ./src/actions/policies.js